import React from "react";
import Select from "react-select";

export default function ReactSelector({
  label,
  touched,
  error,
  name,
  onChange,
  onBlur,
  placeholder,
  options,
  value,
  labelDisabled,
  errorDisabled,
  isMulti,
  isDisabled,
  isLoading,
  customClass,
}) {
  const multiSelectCustomStyle = {
    control: (base) => ({
      ...base,
      zIndex: 0,
      border: "1.5px solid #c9ccd0",
      padding: "12px",
      borderRadius: "10px",
      backgroundColor: "#fafafa",
      boxShadow: "none !important",
      "*": {
        boxShadow: "none !important",
      },
      "&:hover": {
        border: "1.5px solid rgb(224, 224, 224) !important",
      },
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "16px",
      color: "#a4a2a2", // Change the placeholder color
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#f8f8f8", // Change dropdown background color
      borderRadius: "8px",
      marginTop: "4px", // Adjust if needed
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", // Optional: for a subtle shadow effect
    }),
    option: (base, state) => ({
      ...base,
      color: state.isSelected ? "#fff" : "#333", // Change text color for options
      backgroundColor: state.isSelected
        ? "#88BD42" // Active option background color (selected)
        : state.isFocused
        ? "#e0e0e0" // Hover effect background color
        : "#fff", // Default background color
      padding: "8px 10px",
      "&:hover": {
        backgroundColor: state.isSelected ? "#88BD42" : "#e0e0e0", // Maintain active color on hover
      },
    }),
  };

  return (
    <div className={customClass || "col-lg-6"}>
      <div className="common-modal-field">
        {labelDisabled ? null : <label>{label}</label>}

        <Select
          styles={multiSelectCustomStyle}
          className="common-modal-field mb-0"
          classNamePrefix="form-select"
          name={name}
          // defaultValue={colourOptions[0]}
          isDisabled={isDisabled}
          isLoading={isLoading}
          // isClearable={isClearable}
          // isRtl={isRtl}
          // isSearchable={isSearchable}
          isMulti={isMulti}
          value={value}
          placeholder={placeholder || "Select"}
          onChange={onChange}
          options={options}
          onBlur={onBlur}
        />
        {errorDisabled
          ? null
          : touched &&
            error && <p style={{ color: "red", marginBottom: 0 }}>{error}</p>}
      </div>
    </div>
  );
}
